import {
	ADD_USERS
} from "../../constants"

export const addUsers = (users) => {
	return {
		type: ADD_USERS,
		payload: {
			users: users
		}
	}
};


// WEBPACK FOOTER //
// ./src/api/users/actions.js